import { ARBITRUM, AVALANCHE, BASE, FANTOM, OP } from "./chains";

export const SUBGRAPH_URLS = {
  [ARBITRUM]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/arbitrum-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/arbitrum-referrals",
    nissohVault: "https://api.thegraph.com/subgraphs/name/nissoh/gmx-vault",
  },
  [AVALANCHE]: {
    stats: "https://api.thegraph.com/subgraphs/name/gmx-io/gmx-avalanche-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/gmx-io/gmx-avalanche-referrals",
  },
  [OP]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/op-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/op-referrals",
  },
  [BASE]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/base-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/base-referrals",
  },
  [FANTOM]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-stats-v2",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-referrals-v2",
  },

  common: {
    chainLink: "https://api.thegraph.com/subgraphs/name/deividask/chainlink",
  },
};
